import { apiBase, ActionCallback } from '../api';

export class dataFeedApi extends apiBase {
	public static errorHandler: ActionCallback<string>;

	public static post<TOut>(n: string, i: any = null, host: string = null) {
		return new Promise<TOut>((res, rej) => {
			apiBase.postData<TOut>('dataFeed/' + n, (r) => {
				if (r.error != null) {
					if (dataFeedApi.errorHandler)
						dataFeedApi.errorHandler(r.error);
					rej(r.error);
				} else {
					res(r.d);
				}
			}, i, host);
		});
	}

}
